import { useListOrder } from '../../filter';
import { ProductOrderKey } from '../domain';

export const useProductListOrder = () => {
  return useListOrder(ProductOrderKey, 'productOrderBy');
};
